import throttle from 'lodash.throttle';
import { useState, useEffect, useMemo } from 'react';
import { buildVortexRasterUrl } from '@rendering/product-preview';
import { getDevicePixelRatio } from '../utils/devicePixelRatio';
export function useThrottledRasterUrl({ view, renderOptions, containerWidth, cimDocUrl, throttleWaitMs }) {
    const [throttledUrl, setThrottledUrl] = useState('');
    const buildThrottledUrl = useMemo(() => throttle(({ view, renderOptions, containerWidth, cimDocUrl }) => {
        const vortexRasterUrl = buildVortexRasterUrl({
            cimDocUrl,
            modelUrl: view.vortex.model.url,
            stageUrl: view.vortex.stage.url,
            width: containerWidth,
            bgColor: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.bgColor,
            format: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.format,
        });
        setThrottledUrl(vortexRasterUrl);
    }, throttleWaitMs), [throttleWaitMs]);
    useEffect(() => {
        // Wait for containerWidth input
        if (!containerWidth) {
            return;
        }
        buildThrottledUrl({ view, renderOptions, containerWidth: Math.ceil(containerWidth * getDevicePixelRatio()), cimDocUrl });
    }, [buildThrottledUrl, view, renderOptions, containerWidth, cimDocUrl]);
    return throttledUrl;
}
//# sourceMappingURL=useThrottledRasterUrl.js.map